// import React, { useState } from "react";
// import axios from "axios";
// import toast from "react-hot-toast";
// import Loader from "../common/Loader";
// import { FaTimes } from 'react-icons/fa';
// import RichTextEditor from "../common/RichTextEditor";
// const AddSubserviceModal = ({
//   isOpen,
//   onClose,
//   onSubserviceAdded,
//   allSubservices,
//   services
// }) => {
//   const [service, setService] = useState("");
//   const [subserviceName, setSubserviceName] = useState("");
//   const [title, setTitle] = useState("");
//   const [description, setDescription] = useState("");
//   const [images, setImages] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [overview, setOverview] = useState([
//     {
//       name: "",
//       title: "",
//       description: "",
//       points: [{ heading: "", description: "" }],
//       images: []
//     }
//   ]);
//   const [authorName, setAuthorName] = useState("");
//   const [authorDescription, setAuthorDescription] = useState("");
//   const [logo, setLogo] = useState("");

//   // Upload image to Cloudinary
//   const uploadToCloudinary = async (file) => {
//     const formData = new FormData();
//     formData.append("file", file);
//     formData.append("upload_preset", process.env.REACT_APP_UPLOAD_PRESET);

//     const res = await axios.post(
//       `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUD_NAME}/image/upload`,
//       formData
//     );
//     return res.data.secure_url;
//   };

//   const handleImageUpload = async (e) => {
//     const files = e.target.files;
//     if (!files.length) return;
//     setLoading(true);
//     try {
//       const uploadPromises = Array.from(files).map((file) =>
//         uploadToCloudinary(file)
//       );
//       const uploadedUrls = await Promise.all(uploadPromises);
//       setImages([...images, ...uploadedUrls]);
//       toast.success("Images uploaded successfully");
//     } catch (err) {
//       toast.error("Image upload failed");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleLogoUpload = async (e) => {
//     const file = e.target.files[0];
//     if (!file) return;
//     setLoading(true);
//     try {
//       const uploadedUrl = await uploadToCloudinary(file);
//       setLogo(uploadedUrl);
//       toast.success("Logo uploaded successfully");
//     } catch (err) {
//       toast.error("Logo upload failed");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleOverviewImageUpload = async (index, e) => {
//     const files = e.target.files;
//     if (!files.length) return;
//     setLoading(true);
//     try {
//       const uploadPromises = Array.from(files).map((file) =>
//         uploadToCloudinary(file)
//       );
//       const uploadedUrls = await Promise.all(uploadPromises);

//       const updatedOverview = [...overview];
//       updatedOverview[index].images = [
//         ...updatedOverview[index].images,
//         ...uploadedUrls,
//       ];
//       setOverview(updatedOverview);

//       toast.success("Overview images uploaded");
//     } catch (err) {
//       toast.error("Overview image upload failed");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // --- Overview Functions ---
//   const addOverview = () =>
//     setOverview([
//       ...overview,
//       {
//         name: "",
//         title: "",
//         description: "",
//         points: [{ heading: "", description: "" }],
//         images: []
//       }
//     ]);

//   const updateOverview = (index, field, value) => {
//     const newOverview = [...overview];
//     newOverview[index][field] = value;
//     setOverview(newOverview);
//   };

//   const removeOverview = (index) => {
//     if (overview.length > 1) {
//       const newOverview = overview.filter((_, i) => i !== index);
//       setOverview(newOverview);
//     }
//   };

//   // --- Points Functions ---
//   const addPoint = (overviewIndex) => {
//     const updatedOverview = [...overview];
//     updatedOverview[overviewIndex].points.push({ heading: "", description: "" });
//     setOverview(updatedOverview);
//   };

//   const updatePoint = (overviewIndex, pointIndex, field, value) => {
//     const updatedOverview = [...overview];
//     updatedOverview[overviewIndex].points[pointIndex][field] = value;
//     setOverview(updatedOverview);
//   };

//   const removePoint = (overviewIndex, pointIndex) => {
//     const updatedOverview = [...overview];
//     updatedOverview[overviewIndex].points = updatedOverview[overviewIndex].points.filter(
//       (_, i) => i !== pointIndex
//     );
//     setOverview(updatedOverview);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!service) {
//       toast.error("Please select a parent service");
//       return;
//     }

//     if (!subserviceName.trim()) {
//       toast.error("Please enter subservice name");
//       return;
//     }

//     setLoading(true);

//     try {
//       const payload = {
//         service,
//         subserviceName: subserviceName.trim(),
//         title: title.trim() || undefined,
//         description: description
//           .split("\n")
//           .map((line) => line.trim())
//           .filter((line) => line),
//         images,
//         overview: overview.map((item) => ({
//           name: item.name,
//           title: item.title || undefined,
//           description: item.description
//             ? item.description.split("\n").map((d) => d.trim()).filter((d) => d)
//             : undefined,
//           points: item.points.filter((p) => p.heading && p.description),
//           images: item.images.length > 0 ? item.images : undefined,
//           authorName: authorName.trim() || undefined,
//           authorDescription: authorDescription.trim() || undefined,
//           logo: logo || undefined

//         }))
//       };

//       // Clean payload - remove undefined and empty arrays
//       payload.overview = payload.overview.map(item => {
//         const cleanItem = {};
//         Object.keys(item).forEach(key => {
//           if (item[key] !== undefined && item[key] !== "" &&
//             !(Array.isArray(item[key]) && item[key].length === 0)) {
//             cleanItem[key] = item[key];
//           }
//         });
//         return cleanItem;
//       });

//       const response = await axios.post(
//         `${process.env.REACT_APP_API_URL}/subservices/create-subservice`,
//         payload
//       );

//       toast.success("Subservice added successfully");
//       onSubserviceAdded(response?.data?.subservice);

//       // Reset form
//       setService("");
//       setSubserviceName("");
//       setTitle("");
//       setDescription("");
//       setImages([]);
//       setOverview([
//         {
//           name: "",
//           title: "",
//           description: "",
//           points: [{ heading: "", description: "" }],
//           images: []
//         }
//       ]);

//       onClose();
//       if (allSubservices) allSubservices();
//     } catch (err) {
//       console.error("Error adding subservice:", err);
//       toast.error("Failed to add subservice");
//     } finally {
//       setLoading(false);
//     }
//   };

//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
//       <div className="bg-white p-6 rounded-lg w-full max-w-4xl max-h-[90vh] overflow-y-auto">
//         <div className="flex justify-between items-center text-xl font-semibold mb-4">
//           <h2 className="">Add New Subservice</h2>
//           <button
//             type="button"
//             onClick={onClose}
//             className=" hover:text-gray-600 flex items-center gap-2 bg-transparent border-none cursor-pointer"
//           ><FaTimes />
//           </button>
//         </div>

//         <form onSubmit={handleSubmit} className="space-y-6">
//           {/* Select Parent Service */}
//           <div>
//             <label className="block mb-2 font-medium">Parent Service *</label>
//             <select
//               value={service}
//               onChange={(e) => setService(e.target.value)}
//               required
//               className="w-full border px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
//             >
//               <option value="">Select Service</option>
//               {services?.map((srv) => (
//                 <option key={srv._id} value={srv._id}>
//                   {srv.serviceName}
//                 </option>
//               ))}
//             </select>
//           </div>
//           {/* Subservice Name */}
//           <div>
//             <label className="block mb-2 font-medium">Subservice Name *</label>
//             <input
//               type="text"
//               placeholder="Enter subservice name"
//               value={subserviceName}
//               onChange={(e) => setSubserviceName(e.target.value)}
//               required
//               className="w-full border px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
//             />
//           </div>

//           {/* Title */}
//           <div>
//             <label className="block mb-2 font-medium">Title</label>
//             <input
//               type="text"
//               placeholder="Enter title (optional)"
//               value={title}
//               onChange={(e) => setTitle(e.target.value)}
//               className="w-full border px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
//             />
//           </div>

//           {/* Description */}
//           <div>
//             <label className="block mb-2 font-medium">Description</label>
//             <RichTextEditor value={description} onChange={setDescription} placeholder="Enter description" />
//           </div>

//           {/* Main Images */}
//           <div>
//             <label className="block mb-2 font-medium">Subservice Images  (500×400 size)</label>
//             <input
//               type="file"
//               accept="image/*"
//               multiple
//               onChange={handleImageUpload}
//               className="mb-2"
//             />
//             <div className="flex flex-wrap gap-2">
//               {images.map((img, i) => (
//                 <div key={i} className="relative">
//                   <img
//                     src={img}
//                     alt="subservice"
//                     className="w-20 h-20 object-cover rounded border"
//                   />
//                   <button
//                     type="button"
//                     onClick={() => setImages(images.filter((_, index) => index !== i))}
//                     className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-5 h-5 text-xs"
//                   >
//                     ×
//                   </button>
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* Overview */}
//           <div>
//             <h3 className="font-semibold text-lg mb-3">Overview Sections</h3>
//             {overview.map((item, i) => (
//               <div key={i} className="border border-gray-300 p-4 rounded-lg mb-4 bg-gray-50">
//                 <div className="flex justify-between items-center mb-3">
//                   <h4 className="font-medium text-gray-700">Overview Item {i + 1}</h4>
//                   {overview.length > 1 && (
//                     <button
//                       type="button"
//                       onClick={() => removeOverview(i)}
//                       className="text-red-500 hover:text-red-700"
//                     >
//                       Remove
//                     </button>
//                   )}
//                 </div>

//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                   <div>
//                     <label className="block mb-1 text-sm font-medium">Tab Name *</label>
//                     <input
//                       type="text"
//                       placeholder="e.g., Mobile App Development"
//                       value={item.name}
//                       onChange={(e) => updateOverview(i, "name", e.target.value)}
//                       className="w-full border px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
//                       required
//                     />
//                   </div>
//                 </div>

//                 <div className="mt-4">
//                   <label className="block mb-1 text-sm font-medium">Header</label>
//                   <input
//                     type="text"
//                     placeholder="e.g., Building Cross-Platform Apps"
//                     value={item.title}
//                     onChange={(e) => updateOverview(i, "title", e.target.value)}
//                     className="w-full border px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   />
//                 </div>

//                 <div className="mt-4">
//                   <label className="block mb-1 text-sm font-medium">Description</label>
//                   <RichTextEditor
//                     value={item.description}
//                     onChange={(value) => updateOverview(i, "description", value)}
//                     placeholder="Enter overview description"
//                   />
//                 </div>


//                 {/* Points Section */}
//                 <div className="mt-4">
//                   <label className="block mb-1 text-sm font-medium">Points</label>
//                   {item.points.map((point, pIndex) => (
//                     <div key={pIndex} className="grid grid-cols-1 gap-2 mb-2">
//                       <input
//                         type="text"
//                         placeholder="Point Heading"
//                         value={point.heading}
//                         onChange={(e) => updatePoint(i, pIndex, "heading", e.target.value)}
//                         className="w-full border px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
//                       />
//                       <div className="w-full">
//                         <RichTextEditor
//                           value={point.description}
//                           onChange={(value) => updatePoint(i, pIndex, "description", value)}
//                           placeholder="Enter point description"
//                         />
//                       </div>

//                       {item.points.length > 1 && (
//                         <button
//                           type="button"
//                           onClick={() => removePoint(i, pIndex)}
//                           className="text-red-500 text-sm"
//                         >
//                           Remove
//                         </button>
//                       )}
//                     </div>
//                   ))}
//                   <button
//                     type="button"
//                     onClick={() => addPoint(i)}
//                     className="bg-green-500 text-white px-3 py-1 rounded text-sm mt-2"
//                   >
//                     + Add Point
//                   </button>
//                 </div>

//                 {/* Images */}
//                 <div className="mt-4">
//                   <label className="block mb-1 text-sm font-medium">Images  (500×400 size)</label>
//                   <input
//                     type="file"
//                     accept="image/*"
//                     multiple
//                     onChange={(e) => handleOverviewImageUpload(i, e)}
//                     className="mb-2"
//                   />
//                   <div className="flex flex-wrap gap-2">
//                     {item.images.map((img, j) => (
//                       <div key={j} className="relative">
//                         <img
//                           src={img}
//                           alt="overview"
//                           className="w-16 h-16 object-cover rounded border"
//                         />
//                         <button
//                           type="button"
//                           onClick={() => {
//                             const updatedOverview = [...overview];
//                             updatedOverview[i].images = updatedOverview[i].images.filter((_, index) => index !== j);
//                             setOverview(updatedOverview);
//                           }}
//                           className="absolute -top-1 -right-1 bg-red-500 text-white rounded-full w-4 h-4 text-xs"
//                         >
//                           ×
//                         </button>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               </div>
//             ))}
//             <button
//               type="button"
//               onClick={addOverview}
//               className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
//             >
//               + Add Overview Section
//             </button>
//           </div>
//           {/* Author Name */}
//           <div>
//             <label className="block mb-2 font-medium">Author Name</label>
//             <input
//               type="text"
//               placeholder="Enter author name"
//               value={authorName}
//               onChange={(e) => setAuthorName(e.target.value)}
//               className="w-full border px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
//             />
//           </div>

//           {/* Author Description */}
//           {/* <div>
//             <label className="block mb-2 font-medium">Author Description</label>
//             <input
//               type="text"
//               placeholder="Enter author description"
//               value={authorDescription}
//               onChange={(e) => setAuthorDescription(e.target.value)}
//               className="w-full border px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
//             />
//           </div> */}

//           <div>
//             <label className="block mb-2 font-medium">Author Description</label>
//             <RichTextEditor
//               value={authorDescription}
//               onChange={(value) => setAuthorDescription(value)}
//               placeholder="Enter author description"
//             />
//           </div>


//           {/* Logo Upload */}
//           <div>
//             <label className="block mb-2 font-medium">Logo  (160×160 size)</label>
//             <input
//               type="file"
//               accept="image/*"
//               onChange={handleLogoUpload}
//               className="mb-2"
//             />
//             {logo && (
//               <div className="mt-2">
//                 <img
//                   src={logo}
//                   alt="logo"
//                   className="w-20 h-20 object-cover rounded border"
//                 />
//               </div>
//             )}
//           </div>

//           {/* Actions */}
//           <div className="flex justify-end space-x-4 pt-4 border-t">
//             <button
//               type="button"
//               onClick={onClose}
//               className="bg-gray-300 hover:bg-gray-400 px-6 py-2 rounded"
//             >
//               Cancel
//             </button>
//             <button
//               type="submit"
//               disabled={loading}
//               className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-2 rounded disabled:opacity-50"
//             >
//               {loading ? <Loader /> : "Add Subservice"}
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default AddSubserviceModal;

import React, { useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import Loader from "../common/Loader";
import { FaTimes } from 'react-icons/fa';
import RichTextEditor from "../common/RichTextEditor";

const AddSubserviceModal = ({
  isOpen,
  onClose,
  onSubserviceAdded,
  allSubservices,
  services
}) => {
  const [service, setService] = useState("");
  const [subserviceName, setSubserviceName] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [order, setOrder] = useState(0);
  const [overview, setOverview] = useState([
    {
      name: "",
      title: "",
      description: "",
      points: [{ heading: "", description: "" }],
      images: []
    }
  ]);
  const [authorName, setAuthorName] = useState("");
  const [authorDescription, setAuthorDescription] = useState("");
  const [logo, setLogo] = useState("");

  // SEO Fields
  const [metaTitle, setMetaTitle] = useState("");
  const [metaDescription, setMetaDescription] = useState("");
  const [metaKeywords, setMetaKeywords] = useState("");
  const [canonicalUrl, setCanonicalUrl] = useState("");

  // Auto-generate meta title when subservice name changes
  const handleSubserviceNameChange = (e) => {
    const name = e.target.value;
    setSubserviceName(name);
    if (!metaTitle) {
      setMetaTitle(`${name} | BBSR Services`);
    }
  };

  // Upload image to Cloudinary
  const uploadToCloudinary = async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", process.env.REACT_APP_UPLOAD_PRESET);

    const res = await axios.post(
      `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUD_NAME}/image/upload`,
      formData
    );
    return res.data.secure_url;
  };

  const handleImageUpload = async (e) => {
    const files = e.target.files;
    if (!files.length) return;
    setLoading(true);
    try {
      const uploadPromises = Array.from(files).map((file) =>
        uploadToCloudinary(file)
      );
      const uploadedUrls = await Promise.all(uploadPromises);
      setImages([...images, ...uploadedUrls]);
      toast.success("Images uploaded successfully");
    } catch (err) {
      toast.error("Image upload failed");
    } finally {
      setLoading(false);
    }
  };

  const handleLogoUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setLoading(true);
    try {
      const uploadedUrl = await uploadToCloudinary(file);
      setLogo(uploadedUrl);
      toast.success("Logo uploaded successfully");
    } catch (err) {
      toast.error("Logo upload failed");
    } finally {
      setLoading(false);
    }
  };

  const handleOverviewImageUpload = async (index, e) => {
    const files = e.target.files;
    if (!files.length) return;
    setLoading(true);
    try {
      const uploadPromises = Array.from(files).map((file) =>
        uploadToCloudinary(file)
      );
      const uploadedUrls = await Promise.all(uploadPromises);

      const updatedOverview = [...overview];
      updatedOverview[index].images = [
        ...updatedOverview[index].images,
        ...uploadedUrls,
      ];
      setOverview(updatedOverview);

      toast.success("Overview images uploaded");
    } catch (err) {
      toast.error("Overview image upload failed");
    } finally {
      setLoading(false);
    }
  };

  // --- Overview Functions ---
  const addOverview = () =>
    setOverview([
      ...overview,
      {
        name: "",
        title: "",
        description: "",
        points: [{ heading: "", description: "" }],
        images: []
      }
    ]);

  const updateOverview = (index, field, value) => {
    const newOverview = [...overview];
    newOverview[index][field] = value;
    setOverview(newOverview);
  };

  const removeOverview = (index) => {
    if (overview.length > 1) {
      const newOverview = overview.filter((_, i) => i !== index);
      setOverview(newOverview);
    }
  };

  // --- Points Functions ---
  const addPoint = (overviewIndex) => {
    const updatedOverview = [...overview];
    updatedOverview[overviewIndex].points.push({ heading: "", description: "" });
    setOverview(updatedOverview);
  };

  const updatePoint = (overviewIndex, pointIndex, field, value) => {
    const updatedOverview = [...overview];
    updatedOverview[overviewIndex].points[pointIndex][field] = value;
    setOverview(updatedOverview);
  };

  const removePoint = (overviewIndex, pointIndex) => {
    const updatedOverview = [...overview];
    updatedOverview[overviewIndex].points = updatedOverview[overviewIndex].points.filter(
      (_, i) => i !== pointIndex
    );
    setOverview(updatedOverview);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!service) {
      toast.error("Please select a parent service");
      return;
    }

    if (!subserviceName.trim()) {
      toast.error("Please enter subservice name");
      return;
    }

    setLoading(true);

    try {
      const payload = {
        service,
        subserviceName: subserviceName.trim(),
        title: title.trim() || undefined,
        description: description
          .split("\n")
          .map((line) => line.trim())
          .filter((line) => line),
        images,
        order: order || 0,
        overview: overview.map((item) => ({
          name: item.name,
          title: item.title || undefined,
          description: item.description
            ? item.description.split("\n").map((d) => d.trim()).filter((d) => d)
            : undefined,
          points: item.points.filter((p) => p.heading && p.description),
          images: item.images.length > 0 ? item.images : undefined,
        })),
        authorName: authorName.trim() || undefined,
        authorDescription: authorDescription.trim() || undefined,
        logo: logo || undefined,
        // SEO Fields
        metaTitle: metaTitle.trim() || `${subserviceName.trim()} | BBSR Services`,
        metaDescription: metaDescription.trim() || description.split("\n").filter(d => d.trim())[0]?.substring(0, 160) || '',
        metaKeywords: metaKeywords.trim() || `${subserviceName.trim()}, BBSR Services, business solutions`,
        canonicalUrl: canonicalUrl.trim() || `https://www.bbsrservices.co.in/sub-service/${subserviceName.trim().toLowerCase().replace(/\s+/g, '-')}`
      };

      // Clean payload - remove undefined and empty arrays
      payload.overview = payload.overview.map(item => {
        const cleanItem = {};
        Object.keys(item).forEach(key => {
          if (item[key] !== undefined && item[key] !== "" &&
            !(Array.isArray(item[key]) && item[key].length === 0)) {
            cleanItem[key] = item[key];
          }
        });
        return cleanItem;
      });

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/subservices/create-subservice`,
        payload
      );

      toast.success("Subservice added successfully");
      onSubserviceAdded(response?.data?.data);

      // Reset form
      setService("");
      setSubserviceName("");
      setTitle("");
      setDescription("");
      setImages([]);
      setOrder(0);
      setOverview([
        {
          name: "",
          title: "",
          description: "",
          points: [{ heading: "", description: "" }],
          images: []
        }
      ]);
      setAuthorName("");
      setAuthorDescription("");
      setLogo("");
      setMetaTitle("");
      setMetaDescription("");
      setMetaKeywords("");
      setCanonicalUrl("");

      onClose();
      if (allSubservices) allSubservices();
    } catch (err) {
      console.error("Error adding subservice:", err);
      toast.error("Failed to add subservice");
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white p-6 rounded-lg w-full max-w-4xl max-h-[90vh] overflow-y-auto">
        <div className="flex justify-between items-center text-xl font-semibold mb-4">
          <h2 className="">Add New Subservice</h2>
          <button
            type="button"
            onClick={onClose}
            className="hover:text-gray-600 flex items-center gap-2 bg-transparent border-none cursor-pointer"
          ><FaTimes />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Select Parent Service */}
          <div>
            <label className="block mb-2 font-medium">Parent Service *</label>
            <select
              value={service}
              onChange={(e) => setService(e.target.value)}
              required
              className="w-full border px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">Select Service</option>
              {services?.map((srv) => (
                <option key={srv._id} value={srv._id}>
                  {srv.serviceName}
                </option>
              ))}
            </select>
          </div>

          {/* Subservice Name */}
          <div>
            <label className="block mb-2 font-medium">Subservice Name *</label>
            <input
              type="text"
              placeholder="Enter subservice name"
              value={subserviceName}
              onChange={handleSubserviceNameChange}
              required
              className="w-full border px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Title */}
          <div>
            <label className="block mb-2 font-medium">Title</label>
            <input
              type="text"
              placeholder="Enter title (optional)"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              className="w-full border px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Order */}
          <div>
            <label className="block mb-2 font-medium">Display Order</label>
            <input
              type="number"
              placeholder="Enter order number (0, 1, 2, ...)"
              value={order}
              onChange={(e) => setOrder(parseInt(e.target.value) || 0)}
              className="w-full border px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <p className="text-xs text-gray-500 mt-1">Lower numbers appear first in the navbar</p>
          </div>

          {/* Description */}
          <div>
            <label className="block mb-2 font-medium">Description</label>
            <RichTextEditor value={description} onChange={setDescription} placeholder="Enter description" />
          </div>

          {/* Main Images */}
          <div>
            <label className="block mb-2 font-medium">Subservice Images (500×400 size)</label>
            <input
              type="file"
              accept="image/*"
              multiple
              onChange={handleImageUpload}
              className="mb-2"
            />
            <div className="flex flex-wrap gap-2">
              {images.map((img, i) => (
                <div key={i} className="relative">
                  <img
                    src={img}
                    alt="subservice"
                    className="w-20 h-20 object-cover rounded border"
                  />
                  <button
                    type="button"
                    onClick={() => setImages(images.filter((_, index) => index !== i))}
                    className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-5 h-5 text-xs"
                  >
                    ×
                  </button>
                </div>
              ))}
            </div>
          </div>

          {/* Overview */}
          <div>
            <h3 className="font-semibold text-lg mb-3">Overview Sections</h3>
            {overview.map((item, i) => (
              <div key={i} className="border border-gray-300 p-4 rounded-lg mb-4 bg-gray-50">
                <div className="flex justify-between items-center mb-3">
                  <h4 className="font-medium text-gray-700">Overview Item {i + 1}</h4>
                  {overview.length > 1 && (
                    <button
                      type="button"
                      onClick={() => removeOverview(i)}
                      className="text-red-500 hover:text-red-700"
                    >
                      Remove
                    </button>
                  )}
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block mb-1 text-sm font-medium">Tab Name *</label>
                    <input
                      type="text"
                      placeholder="e.g., Mobile App Development"
                      value={item.name}
                      onChange={(e) => updateOverview(i, "name", e.target.value)}
                      className="w-full border px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                      required
                    />
                  </div>
                </div>

                <div className="mt-4">
                  <label className="block mb-1 text-sm font-medium">Header</label>
                  <input
                    type="text"
                    placeholder="e.g., Building Cross-Platform Apps"
                    value={item.title}
                    onChange={(e) => updateOverview(i, "title", e.target.value)}
                    className="w-full border px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>

                <div className="mt-4">
                  <label className="block mb-1 text-sm font-medium">Description</label>
                  <RichTextEditor
                    value={item.description}
                    onChange={(value) => updateOverview(i, "description", value)}
                    placeholder="Enter overview description"
                  />
                </div>

                {/* Points Section */}
                <div className="mt-4">
                  <label className="block mb-1 text-sm font-medium">Points</label>
                  {item.points.map((point, pIndex) => (
                    <div key={pIndex} className="grid grid-cols-1 gap-2 mb-2">
                      <input
                        type="text"
                        placeholder="Point Heading"
                        value={point.heading}
                        onChange={(e) => updatePoint(i, pIndex, "heading", e.target.value)}
                        className="w-full border px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                      />
                      <div className="w-full">
                        <RichTextEditor
                          value={point.description}
                          onChange={(value) => updatePoint(i, pIndex, "description", value)}
                          placeholder="Enter point description"
                        />
                      </div>

                      {item.points.length > 1 && (
                        <button
                          type="button"
                          onClick={() => removePoint(i, pIndex)}
                          className="text-red-500 text-sm"
                        >
                          Remove
                        </button>
                      )}
                    </div>
                  ))}
                  <button
                    type="button"
                    onClick={() => addPoint(i)}
                    className="bg-green-500 text-white px-3 py-1 rounded text-sm mt-2"
                  >
                    + Add Point
                  </button>
                </div>

                {/* Images */}
                <div className="mt-4">
                  <label className="block mb-1 text-sm font-medium">Images (500×400 size)</label>
                  <input
                    type="file"
                    accept="image/*"
                    multiple
                    onChange={(e) => handleOverviewImageUpload(i, e)}
                    className="mb-2"
                  />
                  <div className="flex flex-wrap gap-2">
                    {item.images.map((img, j) => (
                      <div key={j} className="relative">
                        <img
                          src={img}
                          alt="overview"
                          className="w-16 h-16 object-cover rounded border"
                        />
                        <button
                          type="button"
                          onClick={() => {
                            const updatedOverview = [...overview];
                            updatedOverview[i].images = updatedOverview[i].images.filter((_, index) => index !== j);
                            setOverview(updatedOverview);
                          }}
                          className="absolute -top-1 -right-1 bg-red-500 text-white rounded-full w-4 h-4 text-xs"
                        >
                          ×
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
            <button
              type="button"
              onClick={addOverview}
              className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
            >
              + Add Overview Section
            </button>
          </div>

          {/* Author Name */}
          <div>
            <label className="block mb-2 font-medium">Author Name</label>
            <input
              type="text"
              placeholder="Enter author name"
              value={authorName}
              onChange={(e) => setAuthorName(e.target.value)}
              className="w-full border px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Author Description */}
          <div>
            <label className="block mb-2 font-medium">Author Description</label>
            <RichTextEditor
              value={authorDescription}
              onChange={(value) => setAuthorDescription(value)}
              placeholder="Enter author description"
            />
          </div>

          {/* Logo Upload */}
          <div>
            <label className="block mb-2 font-medium">Logo (160×160 size)</label>
            <input
              type="file"
              accept="image/*"
              onChange={handleLogoUpload}
              className="mb-2"
            />
            {logo && (
              <div className="mt-2">
                <img
                  src={logo}
                  alt="logo"
                  className="w-20 h-20 object-cover rounded border"
                />
              </div>
            )}
          </div>

          {/* SEO Section */}
          <div className="border-t pt-4 mt-4">
            <h3 className="text-lg font-semibold text-blue-600 mb-3">SEO Settings</h3>
            <div className="space-y-3">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Meta Title</label>
                <input
                  type="text"
                  placeholder="Meta Title (SEO)"
                  value={metaTitle}
                  onChange={(e) => setMetaTitle(e.target.value)}
                  className="w-full border px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <p className="text-xs text-gray-500">{metaTitle?.length || 0}/60 characters</p>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Meta Description</label>
                <textarea
                  placeholder="Meta Description (SEO)"
                  value={metaDescription}
                  onChange={(e) => setMetaDescription(e.target.value)}
                  rows="3"
                  className="w-full border px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <p className="text-xs text-gray-500">{metaDescription?.length || 0}/160 characters</p>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Meta Keywords</label>
                <input
                  type="text"
                  placeholder="Meta Keywords (SEO)"
                  value={metaKeywords}
                  onChange={(e) => setMetaKeywords(e.target.value)}
                  className="w-full border px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <p className="text-xs text-gray-500">Separate keywords with commas</p>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Canonical URL</label>
                <input
                  type="url"
                  placeholder="Canonical URL"
                  value={canonicalUrl}
                  onChange={(e) => setCanonicalUrl(e.target.value)}
                  className="w-full border px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
            </div>
          </div>

          {/* Actions */}
          <div className="flex justify-end space-x-4 pt-4 border-t">
            <button
              type="button"
              onClick={onClose}
              className="bg-gray-300 hover:bg-gray-400 px-6 py-2 rounded"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={loading}
              className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-2 rounded disabled:opacity-50"
            >
              {loading ? <Loader /> : "Add Subservice"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddSubserviceModal;